var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElmartCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 721,
    height: 754,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#D29EBC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.267 631.287a288.078 288.078 0 00149.12-556.522l-74.56 278.261-74.56 278.261zM278.456 708.52a288.076 288.076 0 01-174.922-134.223 288.075 288.075 0 01105.443-393.521 288.082 288.082 0 01218.599-28.779l-74.56 278.262-74.56 278.261z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElmartCircles);
export default __webpack_public_path__ + "static/media/elmart-circles.b6bb7adb63bd7c04a4cf034b57db20bf.svg";
export { ForwardRef as ReactComponent };